import { useCallback, useRef } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

import { Mean } from './Mean'

export const AbdominalInput: React.FC = () => {
  const abdominalRef = useRef(evaluationAtom.get()?.abdominal ?? [])

  const handleUpdateField = useCallback(
    (index: number, value: number) => {
      const newArr = [...abdominalRef.current]
      newArr[index] = value
      abdominalRef.current = newArr
      patchEvaluationAtom({ abdominal: newArr })
    },
    [],
  )

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(2)
  }, [])

  return (
    <>
      <div className='whitespace-nowrap font-bold xl:font-normal'>
        Abdominal (mm) &nbsp;
      </div>
      {abdominalRef.current.map((val, index) => (
        <div key={`abdominal-${index}`}>
          <p className='block xl:hidden mb-2'>Medida {index + 1}</p>
          <MaskedInput
            value={val}
            placeholder='0'
            mask='integer'
            inputMode='numeric'
            onFocus={handleFocus}
            onChange={(v) => handleUpdateField(index, v)}
          />
        </div>
      ))}
      <div>
        <p className='block xl:hidden mb-2'>Média</p>
        <Mean field='abdominal' />
      </div>
    </>
  )
}
